import { Component, OnInit } from '@angular/core';
import { LoaderService } from './../../../services/loader.service';
import { AppSetting } from './../../../global/appsetting';
import { EmailServiceService, Mail } from './../../../services/email-service.service';
import { GaAnalyticsService, EVENT_TYPES } from 'src/app/services/ga-analytics.service';

@Component({
  selector: 'app-online-ask-us',
  templateUrl: './online-ask-us.component.html',
  styleUrls: ['./online-ask-us.component.scss']
})
export class OnlineAskUsComponent implements OnInit {
  isFormActivate = false;
  isFirstLoad = true;
  name = '';
  email = '';
  phone = '';
  content = '';
  copyEmail = '';
  displaySucceedMsg = false;
  displayFailddMsg = false;
  fieldHasError = [false, false, false, false, false];
  recaptchaKey: string;
  captchaResponse = '';
  enableClick = true;
  displayAboutAsOrigin = false;
  disaplayRobot = true;
  conactPhone = '';
  isLinksActive = false;
  firstLinksActive = true;
  disableAnimation = false;

  constructor(
    public emailService: EmailServiceService,
    public loaderService: LoaderService,
    public appsetting: AppSetting,
    private gaAnalyticsService: GaAnalyticsService
  ) {
    this.recaptchaKey = this.appsetting.reCaptchaKey;
    this.conactPhone = this.appsetting.phone;
  }

  ngOnInit() {
    if (window.location.pathname.indexOf('archonline_ask_us') > -1) {
      this.displayAboutAsOrigin = true;
    }
    let element = document.getElementsByClassName('online-content-cube-wrapper')[0];
    if (!element) {
      element = document.getElementsByClassName('online-content-cube-wrapper-home')[0];
    }
    if(element){
      element.addEventListener('click', () => {
        this.isLinksActive = false;
      });
  }
    
  
  }
  clickOnBlankArea() {
    if (this.enableClick) {
      this.isFormActivate = false;
    }
    this.enableClick = true;
  }
  preventClick(event) {
    this.enableClick = false;
  }
  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }
  changeFormStat() {
    this.isFormActivate = !this.isFormActivate;
    this.isLinksActive = false;
    this.firstLinksActive = false;
    this.isFirstLoad = false;
    if (this.isFormActivate) {
      document.querySelector('.anim-to-disable')?.classList.add('disable-anim');
    } else {
      document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
    }
  }
  changeLinksState() {
    this.isLinksActive = !this.isLinksActive;
    this.firstLinksActive = false;
  }
  openMsgWindow() {
    this.isLinksActive = false;
    const url = 'http://m.me/gilarchonline';
    window.open(url, '_blank');
  }
  openWatsappWindow() {
    this.isLinksActive = false;
    const url = 'https://api.whatsapp.com/send?phone=' + this.conactPhone + '&text=היי,%20יש%20לי%20שאלה';
    window.open(url, '_blank');
  }
  openChatBotWindow() {
    this.isLinksActive = false;
    document.querySelector('.anim-to-disable')?.classList.add('disable-anim');
    this.appsetting.displayChatBot = true;
  }
  resetFields() {
    this.name = '';
    this.email = '';
    this.phone = '';
    this.content = '';
  }
  validateForm() {
    let res = true;
    this.fieldHasError = [false, false, false, false];
    if (this.name === '') {
      this.fieldHasError[0] = true;
      res = false;
    }
    if (this.email === '') {
      this.fieldHasError[1] = true;
      res = false;
    }
    if (this.content === '') {
      this.fieldHasError[2] = true;
      res = false;
    }
    if (this.captchaResponse === '') {
      this.fieldHasError[3] = true;
      res = false;
    }
    if (this.copyEmail !== this.email) {
      this.fieldHasError[4] = true;
      res = false;
    }
    return res;
  }
  mouseEnterBtn() {
    this.disableAnimation = true;
  }
  mouseLeaveBtn() {
    this.disableAnimation = false;
  }
  validateSpacificField(event, index) {
    if (event.target.classList.contains('ng-dirty')) {
      if (event.target.value === '') {
        this.fieldHasError[index] = true;
      } else {
        this.fieldHasError[index] = false;
      }
    }
  }
  sendMail() {
    if (this.validateForm() && this.captchaResponse !== '') {
      let body = '<b>המייל נשלח אליך מ</b>: ' + this.name;
      body += '<br /><b>כתובת</b>: ' + this.email;
      body += '<br /><b>טלפון</b>' + this.phone;
      body += '<br /><b>תוכן ההודעה</b>: <br>' + this.content;
      const mail: Mail = { userEmail: this.email, body: body, mailType: 3, fileList: null, captchaResponse: this.captchaResponse };
      this.loaderService.displayLoader(false);
      this.displayFailddMsg = false;
      this.displaySucceedMsg = false;
      this.emailService.sendMailAskUs(mail).subscribe(
        (res) => {
          this.loaderService.hideLoader();
          if (res) {
            this.resetFields();
            this.displaySucceedMsg = true;
            this.isFormActivate = false;
          } else {
            this.displayFailddMsg = true;
            this.disaplayRobot = false;
            window.setTimeout(() => {
              this.disaplayRobot = true;
            },
              1000
            );
          }
        }, error => {
          this.gaAnalyticsService.logEventToGa('sendMail', 'OnlineAskUsComponent', EVENT_TYPES.Error);
          this.loaderService.hideLoader();
          this.displayFailddMsg = true;
          this.disaplayRobot = false;
          window.setTimeout(() => {
            this.disaplayRobot = true;
          },
            1000
          );
          console.log('could not send email');
        });
    }
  }
}
